<template>
    <div>
        <div :class="classe" class="aviso pt-2 pb-2 text-center"><small>AMBIENTE DE HOMOLOGAÇÃO</small></div>
        <header class="text-uppercase">
            <div class="container">
                <nav class="navbar navbar-expand-lg">
                    <!--<router-link :to="{name: 'index'}" class="navbar-brand" :style="resolution < 400 ? 'width: 130px;' : ''"><img src="./../../assets/img/flag.png" class="img-fluid" alt="PcdoB"></router-link>-->
                    <router-link :to="{name: 'index'}" class="navbar-brand mr-4" :style="resolution < 400 ? 'width: 130px;' : ''" style="width: auto;"><img src="@/assets/img/logo.svg" class="img-fluid mt-2" alt="PcdoB" style="width: auto; height: 70%"></router-link>
                    <div class="navbar-text slogan">
                        <!-- Teoricamente aqui deveria alterar o nome -->
                        Sistema de contribuição do <span>PCdoB</span>
                    </div>
                    <button class="navbar-toggler" type="button">
                        <span class="ion-navicon-round"></span>
                    </button>

                    <div class="collapse navbar-collapse" id="menu">
                        <ul class="navbar-nav mr-0 ml-auto text-right d-none d-md-flex">
                            <li v-for="(m,i) in menu" v-if="m.viewHeader" class="nav-item" :class="m.children ? ' dropdown' : ''">
                                <a v-if="m.children" class="nav-link dropdown-toggle" :href="m.url" @click.prevent="setView(m.id)">{{ m.label }}</a>
                                <router-link v-else-if="m.route" :to="{name: m.route, params: m.params}" class="nav-link">{{ m.label }}</router-link>
                                <a v-else :href="m.url" class="nav-link">{{ m.label }}</a>

                                <div class="dropdown-menu" :id="'menu_' + m.id">
                                    <span v-for="sub in m.children">
                                        <router-link v-if="sub.route" :to="{name: sub.route, params: sub.params}" class="dropdown-item">{{ sub.label }}</router-link>
                                        <a v-else :href="sub.url" class="dropdown-item">{{ sub.label }}</a>
                                    </span>
                                </div>
                            </li>
                        </ul>

                        <ul class="navbar-nav mr-0 ml-auto text-right d-block d-md-none">
                            <li v-for="(m,i) in menu" class="nav-item">
                                <router-link v-if="m.route" :to="{name: m.route, params: m.params}" class="nav-link">{{ m.label }}</router-link>
                                <router-link v-if="m.children" v-for="sub in m.children" :to="{name: sub.route, params: sub.params}" :key="sub.route" class="nav-link">{{ sub.label }}</router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                menu: [],
            }
        },
        computed: {
            classe() {
                return process.env.NODE_ENV
            },
            resolution () {
                return $(document).width()
            },
        },
        methods: {
            montaMenu(){
                let fastLogin = localStorage.getItem('fastLogin')
                this.menu = !_.isNull(this.$store.getters.user) && !fastLogin ? this.$store.getters.getMenuLogado : this.$store.getters.getMenuNaoLogado
            },
            setView (id) {
                let idDrop = 'menu_' + id
                let drop = $('#' + idDrop)
                if(drop.css('display') == 'none'){
                    drop.show()
                }
                else{
                    drop.hide()
                }
            },
        },
        watch: {
            '$store.state.user': function () {
                this.montaMenu()
            }
        },
        async created() {
            await this.montaMenu()

            $(() => {
                $('#menu').find('.nav-item').find('a').click(() => {
                    $('#menu').removeClass('show')
                });
                $('.navbar-toggler').click(() => {
                    if($('#menu').hasClass('show')){
                        $('#menu').removeClass('show')
                    }
                    else{
                        $('#menu').addClass('show')
                    }
                })
                $('body').on('click', async event => {
                    let target = $(event.target)
                    if(
                        _.indexOf(event.target.classList, 'dropdown-item') < 0 &&
                        _.indexOf(event.target.classList, 'dropdown-toggle') < 0 &&
                        _.indexOf(event.target.classList, 'dropdown-menu')
                    ){
                        $('div.dropdown-menu').hide()
                    }
                })
            })
        }
    }
</script>

<style scoped>
    .aviso{
        display: none;
    }
    .staging, .development{
        display: block !important;
        background: #f39c12;
    }

    .navbar-brand{

    }
</style>


// WEBPACK FOOTER //
// src/components/includes/Header.vue